/* eslint-disable no-console */
import { timesheetApi, workScheduleApi } from "@api";
import { selectAuth, useAppSelector } from "@redux";
// import { linkImage } from "@utils";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { WorkTypeResponse } from "../widget/form-sheet-night-shift/site-constructions-form.widget";
import { useUserSelectionHistories } from "src/Utils/Hooks/useUserSelectionHistories";
import { useConstructionSelectionHistories } from "src/Utils/Hooks/useConstructionSelectionHistories";

export interface TimeSheetFormContextProps {
    children: React.ReactNode;
}

interface ITimeSheetContextValue {
    liveletEmployees: any[];
    employees: any[];
    workType: WorkTypeResponse;
    optionContractors: any[];
    optionSiteConstructions: any[];
    loadingSiteConstructions: boolean;
    optionVehicles: any[];
    optionWeather: any[];
    loading: boolean;
    alcoholChecker: any[];
    setLoading: (loading: boolean) => void;
}

const TimeSheetContext = createContext<ITimeSheetContextValue | null>(null);

export function useTimeSheetContext() {
    const context = useContext(TimeSheetContext);
    if (!context) {
        throw new Error("Context must be inside provider");
    }
    return context;
}

export function 
TimeSheetFormContextProvider({ children }: TimeSheetFormContextProps) {
    const [employees, setEmployees] = useState<any[]>([]);
    const [optionVehicles, SetOptionVehicles] = useState<any[]>([]);
    const [optionSiteConstructions, setOptionSiteConstructions] = useState<any[]>([]);
    const [loadingSiteConstructions, setLoadingSiteConstructions] = useState<boolean>(true);
    const [optionWeather, setOptionWeather] = useState<any[]>([]);
    const [optionContractors, setOptionContractors] = useState<any[]>([]);
    const [workType, setWorkType] = useState({} as WorkTypeResponse);
    const [liveletEmployees, setLiveletEmployees] = useState<any[]>([]);
    const [alcoholChecker, setAlcoholChecker] = useState<any[]>([]);

    const [loading, setLoading] = useState(false);

    const setLoadingMemo = useCallback(
        (loading: boolean) => {
            setLoading(loading);
        },
        [setLoading]
    );

    const auth = useAppSelector(selectAuth);
    const { userInfo } = auth;

    const { list } = useUserSelectionHistories(userInfo?.id ?? 0);
    const { constructionList } = useConstructionSelectionHistories(userInfo?.id ?? 0);

    const getListEmployees = () => {
        const userOption = list.map((user) => ({
        label: `${user.last_name} ${user.first_name}`,
        value: user.id.toString(),
        type: user.type,
        }));

        setEmployees(userOption);
    };

    const getListAlcoholChecker = () => {
        const userOption = list.map((user) => ({
        label: `${user.last_name} ${user.first_name}`,
        value: Number(user.id),
        type: user.type,
         }));

        setAlcoholChecker(userOption);
    };

    const getListVehicles = (data) => {
        const vehicles = data.data.data.map((vehicle) => {
            return {
                label: vehicle.name,
                value: vehicle.id.toString(),
            };
        });
        SetOptionVehicles(vehicles);
        // eslint-disable-next-line no-console
    };

    const getListSiteConstructions = () => {
        setLoadingSiteConstructions(true);
        const constructionOption = constructionList.map((c) => ({
            label: c.name,
            value: Number(c.id),
        }));
        setOptionSiteConstructions(constructionOption);
        setLoadingSiteConstructions(false);
    };

    const getListContractors = (data) => {
        const contractors = data.data.data.contractors.map((contractor) => ({
            label: contractor.name,
            value: contractor.id,
        }));

        setOptionContractors(contractors);
    };

    const getListWeather = (data) => {
        const weathers = data.data.data.map((weather) => ({
            label: weather.name,
            value: weather.id,
        }));
        setOptionWeather(weathers);
    };

    const getListWorkType = (data) => {
        setWorkType(data.data.data);
    };
    const getListLiveletEmployee = (data) => {
        const listLiveletEmployees = data.data.map((employee) => {
            return {
                label: `${employee.name}`,
                value: employee.id === 0 ? employee.name : employee.id,
            };
        });

    //     const sortedIds = list.map(user => user.id);
    //     if(sortedIds.length){
    //     listLiveletEmployees = employees.sort((a, b) => {
    //     const indexA = sortedIds.indexOf(Number(a.value));
    //     const indexB = sortedIds.indexOf(Number(b.value));
    //     if (indexA === -1 && indexB === -1) return 0;
    //     if (indexA === -1) return 1;
    //     if (indexB === -1) return -1;
    //     return indexA - indexB;
    //   });
    // }

        setLiveletEmployees(listLiveletEmployees);
    };

    useEffect(() => {
        if (!userInfo || !userInfo.id) return;
        if (!Array.isArray(list) || list.length === 0) return;
        if (!Array.isArray(constructionList) || constructionList.length === 0) return;
        (async () => {
            setLoading(true);
            try {
                const [
                    // employees,
                    optionVehicles,
                    // optionSiteConstructions,
                    optionContractors,
                    optionWeatcher,
                    workType,
                    liveletEmployees,
                    // alcoholChecker,
                ] = await Promise.all([
                    // timesheetApi.listEmployees(),
                    timesheetApi.listVehicles(),
                    // timesheetApi.getListConstructions(),
                    timesheetApi.getListContractors(),
                    timesheetApi.getListWeathers(),
                    workScheduleApi.getWorkTypeByType(),
                    timesheetApi.getListLiveletEmployee(),
                    // timesheetApi.listAlcoholChecker(),
                ]);

                getListEmployees();
                getListVehicles(optionVehicles);
                getListSiteConstructions();
                getListContractors(optionContractors);
                getListWeather(optionWeatcher);
                getListWorkType(workType);
                getListLiveletEmployee(liveletEmployees);
                getListAlcoholChecker();
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        })();
    }, [userInfo, list, constructionList]);

    const value = {
        liveletEmployees,
        employees,
        workType,
        optionContractors,
        optionSiteConstructions,
        loadingSiteConstructions,
        optionVehicles,
        optionWeather,
        loading,
        alcoholChecker,
        setLoading: setLoadingMemo,
    };

    return <TimeSheetContext.Provider value={value}>{children}</TimeSheetContext.Provider>;
}
